import styled from 'styled-components';

export const Container = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
`

export const ContainerBody = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    flex-direction: column;
`

export const Row = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
`